<template>
    <ion-page>
        <base-header v-if="costumer" title="" :buttons="[
            {id: 1, label: 'Salva', action: saveInspection}
        ]" :on-back="onBack"></base-header>
        <ion-content v-if="!loading" :fullscreen="true">
            <div style="padding-top: 24px; padding-bottom: 18px;">
                    <ion-title size="large">{{ title }}</ion-title>                
            </div>
            <template v-if="inspection && inspection.id > 0">
                <div class="ion-margin-vertical ion-padding-horizontal">
                    <div style="border-radius: 8px; padding: 8px; background-color: var(--ion-color-step-150)"
                         class="flex justify-between items-center">
                        <ion-text class="inspection-details-date-title">
                            <b>Stampa</b>
                        </ion-text>
                        <ion-buttons>
                            <!-- style="&#45;&#45;padding-start: 0; &#45;&#45;padding-end: 0; height: fit-content"-->
                            <ion-button :disabled="!isOnline" fill="clear" @click="downloadURI" size="large"
                                        color="primary">
                                <ion-icon :icon="downloadOutline"></ion-icon>
                            </ion-button>
                            <ion-button :disabled="!isOnline || isShareLoading" fill="clear"
                                        @click="sendMail" size="large"
                                        color="primary">
                                <ion-icon v-if="!isShareLoading" :icon="mailOutline"></ion-icon>
                                <ion-spinner v-else></ion-spinner>
                            </ion-button>
                        </ion-buttons>

                    </div>
                    <div v-if="!isOnline" style="text-align: right; padding-top:4px;">
                        <ion-text color="danger"><small>La stampa non è disponibile offline</small></ion-text>
                    </div>
                </div>
            </template>
            <template v-if="inspection && inspection.id > 0">
                <div class="ion-margin-vertical ion-padding-horizontal">
                    <div style="border-radius: 8px; padding: 8px; background-color: var(--ion-color-step-150)"
                         class="flex justify-between items-center">
                        <ion-text class="inspection-details-date-title">
                            <b>Stampa semplificata</b>
                        </ion-text>
                        <ion-buttons>
                            <!-- style="&#45;&#45;padding-start: 0; &#45;&#45;padding-end: 0; height: fit-content"-->
                            <ion-button :disabled="!isOnline" fill="clear" @click="downloadSimplifiedURI" size="large"
                                        color="primary">
                                <ion-icon :icon="downloadOutline"></ion-icon>
                            </ion-button>
                            <ion-button :disabled="!isOnline || isSimplifiedShareLoading" fill="clear"
                                        @click="sendSimplifiedMail" size="large"
                                        color="primary">
                                <ion-icon v-if="!isSimplifiedShareLoading" :icon="mailOutline"></ion-icon>
                                <ion-spinner v-else></ion-spinner>
                            </ion-button>
                        </ion-buttons>

                    </div>
                    <div v-if="!isOnline" style="text-align: right; padding-top:4px;">
                        <ion-text color="danger"><small>La stampa non è disponibile offline</small></ion-text>
                    </div>
                </div>
            </template>
            <div class="ion-padding-horizontal ion-margin-top-half">
                <ion-text class="inspection-details-date-title">
                    <b>{{ dateFormat(inspection?.date) }}</b>
                </ion-text>
            </div>
            <div class="ion-margin-vertical">
                <form class="mei-form">
                    <div class="w-full ion-padding-horizontal">

                        <ion-input v-if="inspection" v-model="inspection!.date" class="mei-input"
                                   type="date" label="Data" label-placement="stacked"></ion-input>
                    </div>
                    <div class="w-full ion-padding-horizontal">
                        <ion-input v-if="inspection" v-model="inspection!.repellent_product"
                                   class="mei-input ion-margin-top"
                                   type="text" label="Prodotto derattizzante" label-placement="stacked"></ion-input>
                    </div>
                    <div class="w-full ion-padding-horizontal ion-margin-top">
                        <ion-label>Esito controllo</ion-label>
                        <ion-segment class="ion-margin-top-half" v-if="inspection" v-model="inspection!.outcome">
                            <ion-segment-button tabindex="-1" class="flex" :value="InspectionOutcome.positive"
                                                style="--margin-top: 0; --margin-bottom: 0">
                                <ion-label>
                                    Positivo
                                    <!--                                    <ion-icon color="success" :icon="checkmarkCircleOutline"></ion-icon>-->
                                </ion-label>
                            </ion-segment-button>
                            <ion-segment-button tabindex="-1" :value="InspectionOutcome.negative"
                                                style="--margin-top: 0; --margin-bottom: 0">
                                <ion-label>
                                    Negativo
                                    <!--                                    <ion-icon color="danger" :icon="closeCircleOutline"></ion-icon>-->
                                </ion-label>
                            </ion-segment-button>
                        </ion-segment>
                    </div>
                    <div class="w-full ion-padding-horizontal ion-margin-top-double">
                        <ion-toggle slot="header" v-model="nonComplianceToggle" class="w-full"
                                    justify="space-between">Apertura non conformità
                        </ion-toggle>
                        <div :class="{'collapse': !nonComplianceToggle}" class="collapsible">
                            <ion-input v-if="inspection" v-model="inspection!.non_compliance"
                                       class="mei-input ion-margin-top"
                                       type="date" label="Data"
                                       label-placement="stacked"></ion-input>
                        </div>
                    </div>
                    <div class="w-full ion-padding-horizontal ion-margin-top-double">
                        <div class="mei-formset-accordion-field-group">
                            <ion-textarea v-if="inspection" class="mei-input mei-note-input" tabindex="-1"
                                          v-model="inspection!.note"
                                          label="Situazione riscontrata"
                                          label-placement="stacked"></ion-textarea>
                        </div>
                    </div>
                    <div class="w-full ion-padding-horizontal ion-margin-top">
                        <div class="w-full ion-padding-half rounded"
                             style="background-color: var(--ion-color-step-150);">
                            <small class="block ion-margin-bottom-half">Firma cliente:</small>
                            <div class="mei-sign-container relative" @click="openSignPad"
                                 :style="{'background-image': `url('${inspection?.costumer_sign || inspection?.costumer_sign_url}')`}">
                                <div class="mei-sign-container-overlay">
                                    <template v-if="isOnline">
                                        <ion-icon class="mei-sign-container-overlay-icon"
                                                  :icon="createOutline"></ion-icon>
                                    </template>
                                    <template
                                        v-if="!isOnline && !inspection?.costumer_sign && inspection!.costumer_sign_url">
                                        <ion-note style="text-align: center" class="ion-padding-horizontal"><em>Anteprima
                                            non disponibile in modalità offline</em></ion-note>
                                    </template>
                                </div>
                            </div>
                        </div>

                    </div>
                    <ion-searchbar
                        v-if="inspection?.outdoor_audits.length > 0 || inspection?.indoor_floor_audits.length > 0 || inspection?.indoor_flying_audits.length > 0"
                        class="ion-margin-top" v-model="search" :animated="true"
                        placeholder="Cerca postazioni..."></ion-searchbar>
                    <div v-if="inspection?.outdoor_audits.length > 0" class="w-full ion-margin-top-half">
                        <ion-text class="mei-formset-title ion-padding-horizontal">Esterno</ion-text>
                        <template v-if="outdoor_audits_filter_results.length > 0">
                            <ion-accordion-group expand="inset" style="margin-top: 8px">
                                <ion-accordion v-for="outdoorAudit in outdoor_audits_filter_results">
                                    <ion-item slot="header" color="light">
                                        <ion-label>
                                            <small class="muted">Pos.</small>&nbsp;
                                            <b>{{ outdoorAudit.label }}</b>
                                        </ion-label>
                                    </ion-item>
                                    <div class="mei-formset-accordion ion-padding" slot="content">
                                        <audit-formset-header :audit="outdoorAudit"
                                                              @updateAudit="auditUpdate(outdoorAudit)"
                                                              @deleteAudit="auditDelete"></audit-formset-header>
                                        <outdoor-audit-formset v-model:note="outdoorAudit.note"
                                                               v-model:quantity="outdoorAudit.quantity"
                                                               v-model:damaged="outdoorAudit.damaged">
                                        </outdoor-audit-formset>
                                    </div>
                                </ion-accordion>
                            </ion-accordion-group>
                        </template>
                        <template v-else>
                            <div class="ion-padding-horizontal" style="text-align: center">
                                <ion-note><small><em>Nessuna postazione per trappole esterne corrispondente</em></small>
                                </ion-note>
                            </div>
                        </template>
                    </div>
                    <div v-if="inspection?.indoor_floor_audits.length > 0" class="w-full ion-margin-top">
                        <ion-text class="mei-formset-title ion-padding-horizontal">Interno a terra</ion-text>
                        <template v-if="indoor_floor_audits_filter_results.length > 0">
                            <ion-accordion-group expand="inset" style="margin-top: 8px">
                                <ion-accordion v-for="indoorFloorAudit in indoor_floor_audits_filter_results">
                                    <ion-item slot="header" color="light">
                                        <ion-label>
                                            <small class="muted">Pos.</small>&nbsp;
                                            <b>{{ indoorFloorAudit.label }}</b>
                                        </ion-label>
                                    </ion-item>
                                    <div class="mei-formset-accordion ion-padding" slot="content">
                                        <audit-formset-header :audit="indoorFloorAudit"
                                                              @updateAudit="auditUpdate(indoorFloorAudit)"
                                                              @deleteAudit="auditDelete"></audit-formset-header>
                                        <indoor-floor-audit-formset
                                            :capture-limit-crawling-lower="indoorFloorAudit.capture_limit_crawling_lower"
                                            :capture-limit-crawling-upper="indoorFloorAudit.capture_limit_crawling_upper"
                                            :capture-limit-rodents-lower="indoorFloorAudit.capture_limit_rodents_lower"
                                            :capture-limit-rodents-upper="indoorFloorAudit.capture_limit_rodents_upper"
                                            v-model:rodents-amount="indoorFloorAudit.rodents_amount"
                                            v-model:crawling-amount="indoorFloorAudit.crawling_amount"
                                            v-model:note="indoorFloorAudit.note">
                                        </indoor-floor-audit-formset>
                                    </div>
                                </ion-accordion>
                            </ion-accordion-group>
                        </template>
                        <template v-else>
                            <div class="ion-padding-horizontal" style="text-align: center">
                                <ion-note><small><em>Nessuna postazione per trappole interne a pavimento
                                    corrispondente</em></small></ion-note>
                            </div>
                        </template>
                    </div>
                    <div v-if="inspection?.indoor_flying_audits.length > 0" class="w-full ion-margin-top">
                        <ion-text class="mei-formset-title ion-padding-horizontal">Interno alati e volanti</ion-text>
                        <template v-if="indoor_flying_audits_filter_results.length > 0">
                            <ion-accordion-group expand="inset" style="margin-top: 8px">
                                <ion-accordion v-for="indoorFlyingAudit in indoor_flying_audits_filter_results">
                                    <ion-item slot="header" color="light">
                                        <ion-label>
                                            <small class="muted">Pos.</small>&nbsp;
                                            <b>{{ indoorFlyingAudit.label }}</b>
                                        </ion-label>
                                    </ion-item>
                                    <div class="mei-formset-accordion ion-padding" slot="content">
                                        <audit-formset-header :audit="indoorFlyingAudit"
                                                              @updateAudit="auditUpdate(indoorFlyingAudit)"
                                                              @deleteAudit="auditDelete"></audit-formset-header>
                                        <indoor-air-audit-formset v-model:quantity="indoorFlyingAudit.quantity"
                                                                  v-model:note="indoorFlyingAudit.note"
                                                                  :capture-limit-upper="indoorFlyingAudit.capture_limit_upper"
                                                                  :capture-limit-lower="indoorFlyingAudit.capture_limit_lower"
                                                                  :capture-limit-acceptability-limits="indoorFlyingAudit.capture_limit_acceptability_limits">
                                        </indoor-air-audit-formset>
                                    </div>
                                </ion-accordion>
                            </ion-accordion-group>
                        </template>
                        <template v-else>
                            <div class="ion-padding-horizontal" style="text-align: center">
                                <ion-note><small><em>Nessuna postazione per trappole interne per insetti volanti
                                    corrispondente</em></small></ion-note>
                            </div>
                        </template>
                    </div>
                    <div
                        v-if="inspection?.outdoor_audits.length == 0 && inspection?.indoor_floor_audits.length == 0 && inspection?.indoor_flying_audits.length == 0"
                        class="ion-padding-horizontal ion-margin-top" style="width: 100%;text-align: center">
                        <ion-note>Non sono ancora stati registrati rilievi per questa ispezione</ion-note>
                    </div>
                </form>
            </div>
            <ion-fab slot="fixed" vertical="bottom" horizontal="end">
                <ion-fab-button @click="openModal">
                    <ion-icon :icon="add"></ion-icon>
                </ion-fab-button>
            </ion-fab>
        </ion-content>
        <ion-content v-else>
            <div style="
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                ">
                <div class="ion-padding ion-text-center">
                    <ion-spinner name="crescent" color="primary"></ion-spinner>
                    <p>Caricamento ispezione...</p>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import {
    alertController,
    IonAccordion,
    IonToggle,
    IonNote,
    IonList,
    IonButton,
    IonSearchbar,
    IonAccordionGroup,
    IonContent,
    IonFab,
    IonFabButton,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    IonText,
    IonSpinner,
    IonTitle,
    IonToolbar,
    IonButtons,
    modalController, IonSkeletonText, IonSegmentButton, IonSegment, IonTextarea, isPlatform, toastController,
} from '@ionic/vue';
import {dateFormat} from "@/utility";
import {useRoute, useRouter} from "vue-router";
import {useCostumersStore} from "@/stores/costumers";
import {useInspectionsStore} from "@/stores/inspections";
import AuditFormsetHeader from "@/components/audits/AuditFormsetHeader.vue";
import OutdoorAuditFormset from "@/components/audits/OutdoorAuditFormset.vue";
import IndoorFloorAuditFormset from "@/components/audits/IndoorFloorAuditFormset.vue";
import IndoorAirAuditFormset from "@/components/audits/IndoorAirAuditFormset.vue";
import BaseHeader from "@/components/BaseHeader.vue";
import {
    add,
    checkmarkCircleOutline,
    closeCircleOutline,
    createOutline,
    downloadOutline, mailOutline, share,
    shareOutline, shareSocialOutline
} from "ionicons/icons";
import Modal from "@/components/modals/Modal.vue";
import {
    IAudit,
    IIndoorFloorTrapAudit,
    IIndoorFlyingTrapAudit,
    IOutdoorTrapAudit,
} from "@/types/audit";
import {computed, onMounted, reactive, ref, watch} from "vue";
import SignaturePad from "@/components/modals/SignaturePad.vue";
import {useNetworkStore} from "@/stores/network";
import {
    baseURL,
    inspectionPrintUrl,
    inspectionSimplifiedPrintUrl,
    inspectionsSendMailUrl,
    inspectionsSendSimplifiedMailUrl
} from "@/services/api";
import {TrapType} from "@/types/trap";
import {IInspection, InspectionOutcome} from "@/types/inspection";
import {EmailComposer} from "capacitor-email-composer";
import axios from "axios";
import {Filesystem} from "@capacitor/filesystem";
import {Directory, Encoding} from "@capacitor/filesystem/dist/esm/definitions";
import {Capacitor} from '@capacitor/core';

const route = useRoute();
const router = useRouter();
const networkStore = useNetworkStore();
const costumersStore = useCostumersStore()
const inspectionsStore = useInspectionsStore()
// INSPECTION ID FROM ROUTE PARAMS
const {inspectionId, costumerId} = route.params;
const loading = ref<boolean>(false);
const search = ref<string>('');
const nonComplianceToggle = ref<boolean>(false);
const costumer = computed(() => costumersStore.getCustomerById(Number(costumerId)));
const inspection = reactive<IInspection>(inspectionId ? (JSON.parse(JSON.stringify(inspectionsStore.getInspectionById(Number(inspectionId)))) as IInspection) : (JSON.parse(JSON.stringify(inspectionsStore.generateBlankInspection(costumer.value!))) as IInspection));
const isOnline = computed(() => networkStore.isOnline);
const isDeviceNative = computed(() => Capacitor.isNativePlatform())
const original: IInspection = JSON.parse(JSON.stringify(inspection));
const isShareLoading = ref<boolean>(false);
const isSimplifiedShareLoading = ref<boolean>(false);


onMounted(() => {
    if (inspection) {
        nonComplianceToggle.value = Boolean(inspection?.non_compliance);
    }
});

watch(nonComplianceToggle, (toggleValue) => {
    if (inspection && !toggleValue) {
        inspection.non_compliance = undefined;
    }
});

const outdoor_audits_filter_results = computed(() => {
    return inspection?.outdoor_audits.filter((audit) => audit.label.toLowerCase().includes(search.value.toLowerCase()))
});
const indoor_floor_audits_filter_results = computed(() => {
    return inspection?.indoor_floor_audits.filter((audit) => audit.label.toLowerCase().includes(search.value.toLowerCase()))
});
const indoor_flying_audits_filter_results = computed(() => {
    return inspection?.indoor_flying_audits.filter((audit) => audit.label.toLowerCase().includes(search.value.toLowerCase()))
});
const title = computed(() => {
    if (inspection && inspection.id > 0) {
        return `Ispezione del ${(new Date(inspection.date).toLocaleDateString())} ${costumer.value ? 'per ' + costumer.value.business_name : 'Cliente'}`;
    } else {
        return `Nuova ispezione ${costumer.value ? 'per ' + costumer.value.business_name : 'Cliente'}`;
    }
});

const downloadURI = () => {
    let link = document.createElement("a");
    link.href = inspection ? baseURL + inspectionPrintUrl(inspection.id) : '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
const downloadSimplifiedURI = () => {
    let link = document.createElement("a");
    link.href = inspection ? baseURL + inspectionSimplifiedPrintUrl(inspection.id) : '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
const sendMail = async () => {
    isShareLoading.value = true;
    axios.get(baseURL + inspectionsSendMailUrl(inspection?.id || 0)).then((response) => {
        if (response.status == 200) {
            toastController.create({
                message: 'Mail inviata correttamente',
                duration: 3000,
                position: 'top',
                color: 'success',
            }).then((toast) => toast.present());
        } else {
            toastController.create({
                message: 'Invio mail fallito',
                duration: 3000,
                position: 'top',
                color: 'danger',
            }).then((toast) => toast.present());
        }
        isShareLoading.value = false;
    })
}
const sendSimplifiedMail = async () => {

    isSimplifiedShareLoading.value = true;

    axios.get(baseURL + inspectionsSendSimplifiedMailUrl(inspection?.id || 0)).then((response) => {
        if (response.status == 200) {
            toastController.create({
                message: 'Mail inviata correttamente',
                duration: 3000,
                position: 'top',
                color: 'success',
            }).then((toast) => toast.present());
        } else {
            toastController.create({
                message: 'Invio mail fallito',
                duration: 3000,
                position: 'top',
                color: 'danger',
            }).then((toast) => toast.present());
        }
        isShareLoading.value = false;
    })
}
const saveInspection = async (routerBack: boolean = true) => {
    loading.value = true;
    await inspectionsStore.saveInspection(inspection!);
    costumersStore.reloadCostumer(costumer.value!.id);
    loading.value = false;
    if (routerBack) {
        router.back();
    }
};
const openModal = async () => {
    const modal = await modalController.create({
        component: Modal,
        componentProps: {
            inspection: inspection,
        }
    });
    await modal.present();
    const creationData = await modal.onWillDismiss();
    if (inspection && creationData.data) {
        const audit = (creationData.data as IOutdoorTrapAudit | IIndoorFloorTrapAudit | IIndoorFlyingTrapAudit);
        switch (audit.type) {
            case TrapType.outdoor:
                inspection.outdoor_audits.push(audit);
                break;
            case TrapType.indoorFloor:
                inspection.indoor_floor_audits.push(audit);
                break;
            case TrapType.indoorFlying:
                inspection.indoor_flying_audits.push(audit);
                break;
        }
    }
}
const openDeleteAlert = async (audit: IAudit) => {
    const alert = await alertController.create({
        header: `Cancellazione postazione ${audit.label}`,
        subHeader: 'Attenzione',
        message: 'Questa operazione non può essere annullata. Procedere comunque?',
        buttons: [
            {
                text: 'Annulla',
                role: 'cancel',
                handler: () => {
                },
            },
            {
                text: 'OK',
                role: 'confirm',
                handler: () => {
                    switch (audit.type) {
                        case TrapType.outdoor: {
                            const auditIndex = inspection!.outdoor_audits.findIndex(auditItem => auditItem.uuid === audit.uuid);
                            if (auditIndex >= 0) {
                                inspection!.outdoor_audits.splice(auditIndex, 1)
                            }
                            return;
                        }
                        case TrapType.indoorFloor: {
                            const auditIndex = inspection!.indoor_floor_audits.findIndex(auditItem => auditItem.uuid === audit.uuid);
                            if (auditIndex >= 0) {
                                inspection!.indoor_floor_audits.splice(auditIndex, 1)
                            }
                            return;
                        }
                        case TrapType.indoorFlying: {
                            const auditIndex = inspection!.indoor_flying_audits.findIndex(auditItem => auditItem.uuid === audit.uuid);
                            if (auditIndex >= 0) {
                                inspection!.indoor_flying_audits.splice(auditIndex, 1)
                            }
                            return;
                        }
                    }
                },
            },
        ]
    });

    await alert.present();
};
const openUpdateAlert = async (audit: IAudit) => {
    const alert = await alertController.create({
        header: `Modifica postazione trappola`,
        subHeader: 'Inserisci l\'etichetta della postazione e l\'area',
        inputs: [
            {
                placeholder: 'Etichetta',
                value: audit.label
            },
            {
                placeholder: 'Area',
                value: audit.area
            }
        ],
        buttons: [
            {
                text: 'Annulla',
                role: 'cancel',
                handler: () => {
                },
            },
            {
                text: 'Modifica',
                role: 'confirm',
                handler: (value: any) => {
                    const label = value[0];
                    const area = value[1];

                    switch (audit.type) {
                        case TrapType.outdoor: {
                            const index = inspection?.outdoor_audits.findIndex(outdoor_audit => audit.uuid === outdoor_audit.uuid);
                            if (index != null && index >= 0) {
                                inspection!.outdoor_audits[index].label = label;
                                inspection!.outdoor_audits[index].area = area;
                            }
                            break;
                        }
                        case TrapType.indoorFloor: {
                            const index = inspection?.indoor_floor_audits.findIndex(indoor_floor_audit => audit.uuid === indoor_floor_audit.uuid);
                            if (index != null && index >= 0) {
                                inspection!.indoor_floor_audits[index].label = label;
                                inspection!.indoor_floor_audits[index].area = area;
                            }
                            break;
                        }
                        case TrapType.indoorFlying: {
                            const index = inspection?.indoor_flying_audits.findIndex(indoor_flying_audit => audit.uuid === indoor_flying_audit.uuid);
                            if (index != null && index >= 0) {
                                inspection!.indoor_flying_audits[index].label = label;
                                inspection!.indoor_flying_audits[index].area = area;
                            }
                            break;
                        }
                    }
                },
            },
        ]
    });

    await alert.present();
};
const openSignPad = async () => {
    const modal = await modalController.create({
        component: SignaturePad,
        cssClass: 'fullscreen'
    });
    modal.present();

    const signature = await modal.onWillDismiss();
    if (inspection && signature.data) {
        inspection!.costumer_sign = signature.data as string;
    }
}
const onBack = () => {
}
const auditDelete = (audit: IOutdoorTrapAudit) => openDeleteAlert(audit);
const auditUpdate = (audit: IAudit) => openUpdateAlert(audit);
</script>

<style scoped lang="scss">
.mei-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.mei-formset-title {
    font-size: 20px;
    font-weight: bold;
}

.mei-sign-container {
    width: 100%;
    border-radius: 8px;
    background-color: white;
    height: 150px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    .mei-sign-container-overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--ion-color-step-100);
        font-size: 24px;

        .mei-sign-container-overlay-icon {
            font-size: 60px !important;
            color: var(--ion-color-step-600);
        }
    }
}

.collapsible {
    overflow: hidden;
    max-height: 70px;
    transition: max-height 0.2s ease-in-out;

    &.collapse {
        max-height: 0;
    }
}
</style>
